<template>
  <el-dialog
    :title="isAdd ? '新增' : '编辑'"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="700px"
    center
    @close="closeDialog"
  >
    <DForm
      ref="formRef"
      :formItems="formItems"
      :model="form"
      label-width="110px"
    />
    <div class="footBtn">
      <el-button type="primary" :loading="submitting" @click="save"
        >确 定</el-button
      >
      <el-button @click="dialogVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  batchSaveAppMarketWhite,
  updateAppMarketWhite,
} from "@/api/appMarketWhite";
import { getProJectList } from "@/api/ozBlockConf";

// TODO: 以下业务码需按后端 /appMarketWhite/batchSave 实际返回确认后替换
const CODE_SUCCESS = 0; // 全部不存在，正常新增
const CODE_PARTIAL_EXIST = "PARTIAL_EXIST_TODO"; // 部分项目已存在，跳过重复仅新增未存在
const CODE_ALL_EXIST = "ALL_EXIST_TODO"; // 所选项目全部已存在

function createDefaultForm() {
  return {
    id: "",
    apkName: "",
    packageName: "",
    marketId: "",
    customerId: "",
    channelId: "",
    projectId: "",
    desc: "",
  };
}

export default {
  props: {
    isShow: Boolean,
    row: Object,
    type: String,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit("update:isShow", val);
      },
    },
    isAdd() {
      return this.type === "add";
    },
    formItems() {
      return [
        {
          label: "应用名称",
          prop: "apkName",
          type: "Input",
          span: 24,
          required: true,
          props: { maxlength: 100 },
        },
        {
          label: "应用包名",
          prop: "packageName",
          type: "Input",
          span: 24,
          required: true,
          props: { maxlength: 200 },
        },
        {
          label: "市场ID",
          prop: "marketId",
          type: "Input",
          span: 24,
          required: true,
          props: { maxlength: 100 },
        },
        {
          label: "客户号",
          prop: "customerId",
          type: "Select",
          span: 24,
          required: true,
          props: {
            filterable: true,
            clearable: true,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.customerList.map((item) => ({
                label: item.cusNo,
                value: item.cusNo,
              })),
            ],
          },
          events: {
            change: this.handleCustomerChange,
          },
        },
        {
          label: "渠道号",
          prop: "channelId",
          type: "Select",
          span: 24,
          required: true,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.form.customerId,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.channelList.map((item) => ({
                label: item.channelName,
                value: item.channelName,
              })),
            ],
          },
          events: {
            change: this.handleChannelChange,
          },
        },
        {
          label: "项目号",
          prop: "projectId",
          type: "Select",
          span: 24,
          required: true,
          props: {
            filterable: true,
            clearable: true,
            disabled: !this.form.channelId,
            options: [
              { label: "ALL", value: "ALL" },
              ...this.projectList.map((item) => ({
                label: item.projectName,
                value: item.projectName,
              })),
            ],
          },
        },
        {
          label: "描述",
          prop: "desc",
          type: "Input",
          span: 24,
          props: {
            type: "textarea",
            rows: 2,
            maxlength: 250,
            showWordLimit: true,
          },
        },
      ];
    },
  },
  watch: {
    async dialogVisible(val) {
      if (val) {
        this.form = { ...createDefaultForm(), ...this.row };
        this.customerList = await this.getOptions({ type: 1 });
        // 编辑态：按行数据回填渠道、项目下拉
        if (!this.isAdd && this.form.customerId) {
          this.channelList = await this.getOptions({
            cusNo: this.form.customerId,
            type: 2,
          });
        }
        if (!this.isAdd && this.form.customerId && this.form.channelId) {
          this.projectList = await this.getOptions({
            cusNo: this.form.customerId,
            channelName: this.form.channelId,
            type: 3,
          });
        }
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.clearValidate();
        });
      } else {
        this.closeDialog();
      }
    },
  },
  data() {
    return {
      form: createDefaultForm(),
      customerList: [],
      channelList: [],
      projectList: [],
      submitting: false,
    };
  },
  methods: {
    async getOptions(params) {
      const res = await getProJectList(
        { page: 1, size: 3000, ...params },
        false,
      );
      if (res && res.code === 0) {
        return res.data.list || [];
      }
      return [];
    },
    async handleCustomerChange(value) {
      this.form.channelId = "";
      this.form.projectId = "";
      this.channelList = [];
      this.projectList = [];
      if (!value) {
        return;
      }
      this.channelList = await this.getOptions({
        cusNo: value,
        type: 2,
      });
    },
    async handleChannelChange(value) {
      this.form.projectId = "";
      this.projectList = [];
      if (!value || !this.form.customerId) {
        return;
      }
      this.projectList = await this.getOptions({
        cusNo: this.form.customerId,
        channelName: value,
        type: 3,
      });
    },
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) {
          return false;
        }
        this.submitting = true;
        try {
          if (this.isAdd) {
            await this.submitAdd();
          } else {
            await this.submitEdit();
          }
        } finally {
          this.submitting = false;
        }
      });
    },
    // 新增：按所选项目号生成 items 提交，按后端 code 区分重复场景
    async submitAdd() {
      const items = [
        {
          apkName: this.form.apkName,
          packageName: this.form.packageName,
          marketId: this.form.marketId,
          customerId: this.form.customerId,
          channelId: this.form.channelId,
          projectId: this.form.projectId,
          desc: this.form.desc,
        },
      ];
      const res = await batchSaveAppMarketWhite({ items });
      const code = res.code;
      const data = res.data || {};
      const successCount =
        data.successCount != null ? data.successCount : items.length;
      const duplicateCount = data.duplicateCount || 0;

      if (code === CODE_ALL_EXIST) {
        // 已存在：弹窗不关闭，行内提示
        this.$message.warning("所选项目均已存在于白名单中");
        return;
      }
      if (code === CODE_PARTIAL_EXIST) {
        // 部分存在：跳过已存在，仅新增未存在项目，关闭弹窗
        this.$message.success(
          `已成功新增 ${successCount} 条，${duplicateCount} 条重复被跳过`,
        );
        this.dialogVisible = false;
        this.$emit("success");
        return;
      }
      if (code === CODE_SUCCESS) {
        // 不存在：正常新增，关闭弹窗
        this.$message.success(`已成功新增 ${successCount} 条`);
        this.dialogVisible = false;
        this.$emit("success");
        return;
      }
      this.$message.error(res.msg || "新增失败");
    },
    // 编辑：单条更新
    async submitEdit() {
      const params = {
        id: this.form.id,
        apkName: this.form.apkName,
        packageName: this.form.packageName,
        marketId: this.form.marketId,
        customerId: this.form.customerId,
        channelId: this.form.channelId,
        projectId: this.form.projectId,
        desc: this.form.desc,
      };
      const res = await updateAppMarketWhite(params);
      if (res && res.code === 0) {
        this.$message.success(res.msg || "编辑成功");
        this.dialogVisible = false;
        this.$emit("success");
      } else {
        this.$message.error((res && res.msg) || "编辑失败");
      }
    },
    closeDialog() {
      this.form = createDefaultForm();
      this.channelList = [];
      this.projectList = [];
      this.submitting = false;
      this.$refs.formRef && this.$refs.formRef.clearValidate();
    },
  },
};
</script>

<style scoped lang="scss">
.footBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
</style>
